'use strict';
module.exports = function(eventName, payload) {
  var defaults, ref;
  if (payload == null) {
    payload = {};
  }
  defaults = {
    b: Cookie.get('b'),
    pageId: location.pathname
  };
  payload = Object.assign({}, payload, defaults);
  if (typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null) {
    if ((ref = OptimizeSuite.TrackingHub) != null) {
      ref.add("" + eventName, payload);
    }
  }
};

